import { 
    HomePage, 
    Explore, 
    Profile, 
    Settings, 
    Announcements, 
    Applications, 
    About, 
    FAQ, 
    PageNotFound, 
    Recommendations, 
    PublicCompanyProfile
} from "../../pages";
import { ForgotPassword, SignIn, SignUp } from "../../pages/(auth)";
import RegistrationSuccess from "../../pages/(auth)/RegistrationSuccess";
import MainSignup from "../../pages/MainSignup";
import Layout from "./Layout";


export const nav = [

    // intern navs
    {   path: "/", 
        name: "Home", 
        element: <Layout><HomePage/></Layout>, 
        isMenu:false, 
        isPrivate:true
    },
    {   path: "/login", 
        name: "Login", 
        element: <SignIn/>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path: "/register", 
        name: "Register", 
        element: <SignUp/>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path: "/forgot-password", 
        name: "forgot-password", 
        element: <ForgotPassword/>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path: "/explore", 
        name: "Explore", 
        element: <Layout><Explore/></Layout>, 
        isMenu:true, 
        isPrivate:true
    },
    {   path: "/profile", 
        name: "Profile", 
        element: <Layout><Profile/></Layout>, 
        isMenu:false, 
        isPrivate:true
    },
    {   path: "/settings", 
        name: "Settings", 
        element: <Layout><Settings/></Layout>, 
        isMenu:false, 
        isPrivate:true
    },
    {   path: "/announcements", 
        name: "Announcements", 
        element: <Layout><Announcements/></Layout>, 
        isMenu:true, 
        isPrivate:true
    },
    {   path: "/applications", 
        name: "Applications", 
        element: <Layout><Applications/></Layout>, 
        isMenu:true, 
        isPrivate:true
    },
    {   path: "/about", 
        name: "About", 
        element: <Layout><About/></Layout>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path: "/faq", 
        name: "FAQ", 
        element: <Layout><FAQ/></Layout>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path:"/main-signup", 
        name:"MainSignup", 
        element:<MainSignup/>, 
        isMenu:false, 
        isPrivate:false
    },
    {   path: "/companies/:companyId", 
        name: "CompanyProfile", 
        element: <Layout><PublicCompanyProfile/></Layout>, 
        isMenu: false, 
        isPrivate: false
    },
    {
        path: "/registration-success",
        name: "RegistrationSuccess", 
        element: <RegistrationSuccess />,
        isMenu:false, 
        isPrivate: false
    }
    // {path:"/recommendations", name:"Recommendations", element:<Layout><Recommendations/></Layout>, isMenu:false, isPrivate:true,},
    
    
]